import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconProductPlacement$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconProductPlacement extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ba0b4aadf144b99be819506c2d310fc5b53485bb', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1e30e2909fc18e55cecf8c664fc358202d57a540', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'aeac665092f316daf9c17918273ae9a0e7cb31a5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 2.002 19.36 2c.223 0 .304.023.385.067a.45.45 0 0 1 .19.189c.043.081.066.162.066.385v16.718c0 .223-.023.304-.067.385a.45.45 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.45.45 0 0 1-.19-.189.6.6 0 0 1-.064-.285L2 2.641c0-.223.023-.304.067-.385a.45.45 0 0 1 .189-.19.6.6 0 0 1 .285-.064M18.5 3.5h-15v15h15zm-8.356 11.501V12.16h1.092q.636 0 1.146-.18t.87-.51.552-.81.192-1.08q0-1.2-.732-1.89T11.236 7H8.44v8.001zm.972-4.233h-.972v-2.34h.972q.54 0 .84.306t.3.858q0 .54-.3.858t-.84.318", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-product-placement", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-product-placement"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-product-placement":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconProductPlacement$1);
            }
            break;
    } });
}

const CosmosIconProductPlacement = CosmosIconProductPlacement$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconProductPlacement, defineCustomElement };
